export const SEN_STATUSES = {
    K: 'K',
    N: 'N',
    E: 'E',
}
